import {SortDirection} from '../../../../utils/sort-state';

interface Shares {
  [category: string]: number;
}

export interface BrandShares {
  brandKey: string;
  shares: Shares;
}

export interface ContentCategoryDistributionResponse {
  myBrand: BrandShares;
  myCompetitors: BrandShares[];
}

export interface Row {
  category: string;
  [brand: string]: string | number;
}

export enum CCDEventType {
  SORT,
  HOVER_IN,
  HOVER_OUT,
}

export interface CCDEvent {
  type: CCDEventType,
  colId: string,
  sortDirection?: SortDirection
}
